import LargeBanner from './scripts';
import './styles/largeBanner.scss';

LargeBanner.init();
